<template>
  <div class="form-group form-inline">
    <div class="mx-auto">
      <md-button class="md-small" @click="calc(-1)">-</md-button>
      <input
        type="text"
        pattern="\d*"
        :id="`${type}${item.itemId}`"
        class="form-control text-center quantity"
        :class="{ 'required-error': !isHiddenItem && isRequired && count === '' /* 前回納品後個数が0以上の商品が対象 */ }"
        v-model=count
        min="0"
        @change=changeQuantity
        @blur=changeQuantity
      >
      <md-button class="md-small" @click="calc(1)">+</md-button>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'QuantityInput',
    props: {
      type: String,
      quantity: [String, Number],
      item: {},
      isHiddenItem: Boolean,
      isRequired: Boolean,
    },
    mounted() {
      this.changeQuantity();
    },
    data() {
      return {
        count: this.quantity,
      };
    },
    methods: {
      calc(num) {
        let count = parseInt(this.count || 0, 10) + num;
        if (count < 0) count = 0;
        this.count = count;
        this.changeQuantity();
        return true;
      },
      changeQuantity() {
        if (this.count !== '' && !/^([1-9]\d*|0)$/.test(this.count)) {
          alert('0以上の数値を入力してください。');
          this.count = '';
        }
        this.$emit('changeQuantity', this.type, this.count);
      },
    },
  };
</script>

<style lang="scss" scoped>
  .form-group {
    margin-bottom: 0;
    width: 100%;

    .mx-auto {
      width: 100%;
      input[type=text] {
        width: 3rem;

        &.required-error,
        &.error {
          background: #FCCBCB;
        }
      }

      .md-button.md-small {
        min-width: 23%;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/parts/QuantityInput.vue?a58d5f02